import React from "react";
import PropTypes from "prop-types";
import logo from "Resources/Images/logo_46_37.jpg"
import logo1 from "Resources/Images/logont_68_37.jpg"
import 'Resources/Css/bootstrap.min.css'
import 'Resources/Css/StyleSheet.css'
import 'Resources/Css/css.css'
import 'Resources/Css/css1.css'
import 'react-widgets/dist/css/react-widgets.css'
import axios from 'axios';
import Config from "constants/configs";
import { getUserLogin, getBranch, getUrl, getDomain } from '../../utils/utils';
import Cookies from 'universal-cookie';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      objChiNhanh: "",
      iBranch: getBranch(),
      objUser: getUserLogin(),
      urlAPI: getDomain(),
    };
  }

  componentDidMount() {
    const cookies = new Cookies();
    var userToken = cookies.get('userTokenDaiLy');
    if (userToken === "" || typeof userToken === "undefined") {
      window.location.href = "/DangNhap";
    }

    // if (this.props.isBranch !== false) {
    //   axios.get(this.state.urlAPI + "chinhanh/listChiNhanh?sUserName=" + this.state.objUser.UserName,
    //     {
    //       headers: {
    //         Authorization: userToken.substring(6)
    //       }
    //     }
    //   )
    //     .then(d => {
    //       const cookies = new Cookies();
    //       var chinhanh = cookies.get('ChiNhanh');
    //       if (typeof chinhanh === "undefined" || chinhanh === "") {
    //         cookies.set('ChiNhanh', d.data.List[0].BranchID, { path: '/' });
    //       }
    //       let state = this.state;
    //       state.objChiNhanh = d.data;
    //       if (this.props.isNotBranchTong) {
    //         var lst = d.data.List.filter(x => x.BranchID !== 0);
    //         cookies.set('ChiNhanh', lst[0].BranchID, { path: '/' });
    //         state.iBranch = lst[0].BranchID;
    //         window.location.reload(false);
    //       }

    //       this.setState({ state });
    //     }).catch(err => {
    //       console.log(err.data);
    //     });
    // }
  }
  renderSelectChiNhanh() {
    let objChiNhanh = this.state.objChiNhanh;
    if (typeof objChiNhanh.List != "undefined") {
      return objChiNhanh.List.map((chinhanh, index) => {
        const { BranchName, BranchID } = chinhanh
        return (
          <option value={BranchID}>{BranchName}</option>
        )
      })
    }
  }
  onChangeChiNhanh(field, event) {
    const cookies = new Cookies();
    cookies.set('ChiNhanh', event.target.value, { path: '/' });
    this.setState({ iBranch: event.target.value });
    window.location.reload(false);
  }
  render() {
    return (
      <div class="top">
        <div class="top-left">
          <div class="img">
            <img src={logo} alt="" width="46" height="37" />
          </div>
          <div class="text">
            Phần mềm quản lý sản xuất và kinh doanh <span><a target="_blank" href="http://niemtinvn.com">Niềm Tin</a></span>
            |
            Tổng đài hỗ trợ : <a href="tel:0328666932">0328 666 932</a> - Nhánh 1
            |
            <a href="https://www.facebook.com/groups/PhanmembanhangNiemTin" target="_blank">Facebook hỗ trợ</a>
          </div>
        </div>
        <div class="top-right">
          <div>

            {this.state.objChiNhanh.List && this.state.objChiNhanh.List.length > 0 && (
              <div>
                <select disabled={this.props.isDisable} class="form-control selectCss" onChange={this.onChangeChiNhanh.bind(this, "iBranch")} value={this.state.iBranch}>
                  {this.state.objChiNhanh.List.map((chinhanh, index) => {
                    return <option value={chinhanh.BranchID}>{chinhanh.BranchName}</option>;
                  })}
                </select>
              </div>
            )}

          </div>
          <div>
            <img src={logo1} alt="#" width="68" height="37" />
          </div>
        </div>
      </div>
    );
  };
}
Header.propTypes = {
  showBackground: PropTypes.bool,
  isNotBranchTong: PropTypes.bool,
  isBranch: PropTypes.bool,
  isDisable: PropTypes.bool,
};

export default Header;
